<div>
  <mat-drawer-container hasBackdrop="false">
    <mat-drawer-content>
      <button [ngClass]="{'hasSpecError': hasSpecError}" mat-icon-button (click)="drawer.toggle(); resetFileSelection()" [disabled]="!canUpload">
        <mat-icon *ngIf="!hasSpecError">attach_file_filled</mat-icon>
        <mat-icon *ngIf="hasSpecError" matTooltip="Error al recuperar la especificación de carga de archivos.">info</mat-icon>
      </button>
    </mat-drawer-content>
    <mat-drawer class="drawer-container" mode="push" position="end" #drawer>
      <input type="file" id="file" [accept]="acceptsExtensions" (change)="selectFile($event)" #fileInput [disabled]="!canUpload">
      <button mat-icon-button (click)="uploadFile()" [disabled]="!isFileSelected || hasSpecError">
        <mat-icon *ngIf="!isLoading">publish</mat-icon>
        <mat-spinner *ngIf="isLoading" [diameter]="24"></mat-spinner>
      </button>
    </mat-drawer>
  </mat-drawer-container>
</div>
